// PACKAGES
import React from 'react'
import { useContext } from 'use-context-selector'
// UI
import { Grid } from '@material-ui/core'
import WotcStep from './WotcStep'
// CONTEXTS
import { PostingContext } from '../../contexts/PostingContext'

const AdditionalStepsList = () => {
  const [postingState] = useContext(PostingContext)

  return (
    <Grid container justifyContent='center' alignContent='center'>
      <WotcStep actSection='disclaimer' redirect={postingState.posting?.url} />
    </Grid>
  )
}

export default AdditionalStepsList
